import React from 'react';

import { isLoggedInUserRoot } from '@paragon/login-tools';
import {
  getTrussDesignDrawingOptionsToSend,
  TrussDesignDrawingOptionsFields,
  useTrussDesignDrawingOptions,
} from '@paragon/material';
import { closeCurrentPopup, Dialog } from '@paragon/popup-state';

import { downloadTrussDesignDrawings } from '../../store/actions/download';
import { getScopeComponentDesignGuids, ProjectActionScope } from '../../store/projectActionScope';
import { canIgnoreTddErrors } from '../../store/selectors/canIgnoreTddErrors';
import { useAppDispatch, useAppSelector } from '../hooks';

export default function TrussDesignDrawingDownloadDialog({ scope }: { readonly scope: ProjectActionScope }) {
  const dispatch = useAppDispatch();

  const isRootUser = useAppSelector(isLoggedInUserRoot);
  const canIgnoreErrors = useAppSelector(canIgnoreTddErrors);
  const annotationTemplates = useAppSelector((state) => state.annotationTemplates);
  const isOneComponent = getScopeComponentDesignGuids(scope).length === 1;

  const [options, setOptions] = useTrussDesignDrawingOptions(annotationTemplates);

  return (
    <Dialog
      title="Download Truss Design Drawings"
      onCancel="close"
      submitText="Download"
      onSubmit={() => {
        dispatch(downloadTrussDesignDrawings(getTrussDesignDrawingOptionsToSend(options), scope));
        dispatch(closeCurrentPopup());
      }}
    >
      <TrussDesignDrawingOptionsFields
        options={options}
        onChange={setOptions}
        templates={annotationTemplates}
        showFileType={!isOneComponent}
        showForceDarkMode={isRootUser}
        showIgnoreErrors={canIgnoreErrors}
        showShareLayout
      />
    </Dialog>
  );
}
